import { ChangeDetectorRef, Directive, effect, ElementRef, inject, input, OnDestroy, Renderer2, ViewContainerRef } from '@angular/core';
import { EnpsDirective } from '@common/components/base/enps-directive';
import { Record } from '@common/data-models/records/record';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { CriteriaObj } from '@src/suite/common/data-models/criteria/criteria-obj';

@Directive({ selector: '[st-adorner]' })
export abstract class AbstractAdornerDirective extends EnpsDirective implements OnDestroy {
    protected abstract get locationID(): string;

    el = inject(ElementRef);
    renderer = inject(Renderer2);
    globalTablesService = inject(GlobalTablesService);
    viewContainerRef = inject(ViewContainerRef);
    cdr = inject(ChangeDetectorRef);

    itemType = input('');
    data = input<StorytellingRecord>();

    protected predefinedIconsMap: { [type: string]: { icon: string; color: string } } = {
        GRAPHIC: { icon: 'bar_chart', color: '#f15a24' },
        INTERACTIVE: { icon: 'ads_click', color: '#c1272d' },
        AUDIO: { icon: 'volume_up', color: '#321911' },
        LIVEVIDEO: { icon: 'live_tv', color: '#662D91' },
        TEXT: { icon: 'history_edu', color: '#000000' },
        PHOTO: { icon: 'image', color: '#006837' },
        VIDEO: { icon: 'videocam', color: '#2e3192' },
        SOCIALPROMOTION: { icon: 'public', color: '#0d47a1' },
        SOCIAL: { icon: 'public', color: '#0d47a1' },
    };

    constructor() {
        super();
        effect(() => {
            if (this.data()) {
                this.applyAdorner();
            }
            if (this.itemType()) {
                this.applyAdorner();
            }
        });
    }

    protected applyAdorner() {
        const vcToApply = this.findCriteriaV2();
        this.applyVC(vcToApply);
        this.cdr.markForCheck();
    }

    public findCriteriaV2(): { visibilityCriteria: CriteriaObj; adorner: Adorner } {
        const vcs = Record.adornerVisibilityCriteriaCache[this.locationID];
        let vcToApply: { visibilityCriteria: CriteriaObj; adorner: Adorner } = null;
        if (vcs && vcs.length) {
            for (const vc of vcs) {
                const rec = this.data();
                let visible = false;
                if (vc.visibilityCriteria) {
                    try {
                        if (rec && Object.keys(rec).length > 0) {
                            visible = eval(vc.visibilityCriteria.criteria);
                        } else {
                            visible = eval(vc.visibilityCriteria.criteria);
                        }
                    } catch (e) {
                        visible = false;
                    }
                }

                if (visible && vc && vc.adorner) {
                    vcToApply = vc;
                    break;
                }
            }
        }
        return vcToApply;
    }
    protected abstract applyVC(vcToApply: { visibilityCriteria: CriteriaObj; adorner: Adorner }): void;
}
